export default class LayerOptionStore {
  // public layers: string[] = ['大区', '巡检区', '禁行区', '停车区', '路网', '测量点', '照片点'];
  public layers: string[] = [];

  public isNavShow(layerName: string) {
    const isHas = this.layers.includes(layerName);
    if (isHas) {
      this.layers = this.layers.filter(item => item !== layerName);
    } else {
      this.layers = [...this.layers, layerName];
    }
  }

  public isHas(layerName: string) {
    return this.layers.includes(layerName);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/LayerOptionStore/LayerOptionStore.ts